import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';

var QuestionMark = function QuestionMark(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14V16H9V14H11Z",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6 5.79 7.79 4 10 4C12.21 4 14 5.79 14 8C14 9.28292 13.21 9.97332 12.4408 10.6455C11.711\n      11.2833 11 11.9046 11 13H9C9 11.1787 9.94212 10.4566 10.7704 9.82168C11.4202 9.32361 12 8.87922 12\n      8C12 6.9 11.1 6 10 6C8.9 6 8 6.9 8 8H6Z",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228\n      4.47715 20 10 20ZM18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.30558 18.5 1.5 14.6944 1.5 10C1.5 \n      5.30558 5.30558 1.5 10 1.5C14.6944 1.5 18.5 5.30558 18.5 10Z",
    fill: "#444749"
  }));
};

QuestionMark.propTypes = {
  className: PropTypes.string
};
var IconQuestionMark = styled(QuestionMark).withConfig({
  displayName: "icon-question-mark__IconQuestionMark",
  componentId: "sc-sqrtze-0"
})(["width:", ";height:", ";"], function (props) {
  return props.small ? '14px' : '20px';
}, function (props) {
  return props.small ? '14px' : '20px';
});
export default IconQuestionMark;